// TODO: replace with the production domain before launch — used for canonical
// URLs, Open Graph tags, sitemap.xml generation and robots.txt.
export const SITE_URL = 'https://turbosurge.example.com';
export const SITE_NAME = 'Turbo Surge';
